import axios from 'axios';

export default class AccountService {
  get URL() {
    return process.env.VUE_APP_WEB_API_URL;
  }

  get ApiUrl() {
    return process.env.VUE_APP_WEB_API_HOST;
  }

  constructor() {}

  getSingleSignOnAccounts(email) {
    return axios.get(`${this.URL}accounts?email=${email}`);
  }
}

export const accountService = new AccountService();
